const disableScrollOnAdminPps = () => {
  const html = document.querySelector("html");
  if (window.location.pathname.includes("admin/pps")) {
    // html.classList.add("no-scroll");
  }
}

const disableScrollOnWorkPermitSignatures = () => {
 const rightContainer = document.querySelector(".right-container");
 if (window.location.pathname.includes("work_permits")
   && window.location.pathname.includes("signatures")) {
   rightContainer.classList.add("no-overflow-y");
 }
}

export { disableScrollOnAdminPps };
export { disableScrollOnWorkPermitSignatures };
